import { DEFAULT_UPMS_RESOURCE_ICON } from '@/constants.js';

export default {
    name: 'AdminAsideMenu',

    render(h) {
        let _this = this;
        return h('el-menu', {
            'class': _this.menuClass,
            ref: 'adminAsideMenu',
            props: {
                mode: 'vertical',
                defaultActive: _this.defaultActive,
                collapse: _this.collapsed,
                defaultOpeneds: _this.defaultOpeneds,
                router: true
            },
            on: {
                select: _this.onSelected
            },
        }, _this.recurisiveLoadSubMenu(h, _this.menuList, 1));
    },
    props: {
        menuClass: {
            type: String,
            default: 'el-menu-vertical-dark'
        },
        popperMenuClass: {
            type: String,
            default: 'el-menu-vertical-dark'
        },
        menuList: {
            type: Array,
            default: []
        },
        defaultActive: {
            type: String,
            default: ''
        },
        defaultOpeneds: {
            type: Array,
            default: []
        },
        defaultMenuIcon: {
            type: String,
            default: DEFAULT_UPMS_RESOURCE_ICON
        },
        defaultMenuIconSize: {
            type: String,
            default: '14px'
        },
        collapsed: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        /**
         * 递归处理加载渲染菜单树结构
         */
        recurisiveLoadSubMenu(h, menus, level) {
            let elements = [];
            if (menus && menus.length) {
                menus.forEach((menu) => {
                    if (menu.menuType == 0) {
                        let item = null;
                        if (this.hasSubMenu(menu.subMenuList)) {
                            item = h('el-submenu', {
                                props: {
                                    index: menu.menuPath,
                                    popperClass: this.popperMenuClass,
                                    slot: 'title'
                                }
                            }, [
                                h('template', { slot: 'title' }, [h('i', { 'class': [this.formatMenuIcon(menu)], 'style': [this.formatMenuIconStyle(menu)] }), h('span', menu.menuName)]),
                                this.recurisiveLoadSubMenu(h, menu.subMenuList, level + 1)
                            ]);
                            elements.push(item);
                        } else {
                            item = h('el-menu-item', {
                                props: {
                                    index: menu.menuPath
                                }
                            }, [h('i', { 'class': [this.formatMenuIcon(menu)], 'style': [this.formatMenuIconStyle(menu)] }), h('span', { slot: 'title' }, menu.menuName)]);
                            elements.push(item);
                        }
                    }
                });
            }
            return elements;
        },
        /**
         * 判断子菜单中是否有菜单
         * @param {*} subMenuList 
         */
        hasSubMenu(subMenuList) {
            let has = subMenuList && subMenuList.length;
            if (has) {
                for (let menu of subMenuList) {
                    if (menu.menuType == 0) {
                        return true;
                    }
                }
            }
            return false;
        },
        /**
         * 格式化菜单ICON
         */
        formatMenuIcon(menu) {
            let menuIcon = '';
            //一级菜单及存在子菜单的菜单优先使用自定义的ICON图标,如果没有则使用默认的
            if (menu.menuLevel === 1 || (menu.subMenuList && menu.subMenuList.length)) {
                if (menu.menuIcon) {
                    menuIcon = menu.menuIcon;
                }
            }
            return menuIcon ? menuIcon : this.defaultMenuIcon;
        },
        /**
         * 格式化菜单ICON的样式
         */
        formatMenuIconStyle(menu) {
            let iconStyle = { fontSize: this.defaultMenuIconSize };
            if (menu.menuIconStyle) {
                let styles = menu.menuIconStyle.split(';');
                styles.forEach((style) => {
                    if (style && style.trim()) {
                        let stylePair = style.split(':');
                        if (stylePair && stylePair.length == 2) {
                            iconStyle[stylePair[0].trim()] = stylePair[1].trim();
                        }
                    }
                });
            }
            return iconStyle;
        },
        /**
         * 处理菜单选中的事件
         * @param {*} index 
         * @param {*} indexPath 
         */
        onSelected(index, indexPath) {
            this.$emit('select', index, indexPath);
        }
    }
};